import React, { useEffect, useState } from "react";

// Images
import descriptionimage from "../../images/Blog/description_image.png";
import contentimage from "../../images/Blog/content_image.png";
import apartment_img from "../../images/Blog/apartment.png";
import Profile_avatar from "../../images/Blog/avatar.png";
import Arrow from "../../images/Blog/arrow.png";
import Card_img from "../../images/Blog/blog_cardimg.png";

// Components
import Button from "../../Components/Button";
import Blog_filter from "../../Components/Blog/Filter";
import Chatwithus from "../../Components/chatwithus";
import Dream_Property from "../../Components/Blog/DreamProperty";
import { useLocation, useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
function BlogDescription() {
  const [article, setArticle] = useState();

  const { id } = useParams();
  const location = useLocation();
  const property = location.state?.property;

  const { data } = useFetch("http://localhost:1337/api/properties?populate=*");
  useEffect(() => {
    if (data) {
      setArticle(data?.data);
    }
  }, [data]);

  return (
    <>
      <Blog_filter />

      {/* Blog Heading */}

      <div className="max-w-[985px] mx-auto flex flex-col items-center text-left  mt-[60px] px-5 sm:text-center">
        {/* <Button
                    name={"Buying"}
                    design={"filled"}
                    action={"external-linking"}
                    url={"https://www.google.com/"}
                /> */}

        <button className="bg-yellow  px-4 py-2 text-[18px]">
          {property.category}
        </button>

        <h1 className="max-w-[770px] font-alibaba text-[35px] leading-[50px] font-bold my-[20px] sm:text-[45px] sm:leading-[55px]">
          {property.heading}
        </h1>

        <p className="text-[20px] text-font-grey font-normal leading-[32px] mt-[10px]">
          {property.user}
        </p>
      </div>

      {/* Blog Image */}
      <img
        className="w-full h-[300px] sm:h-[565px] object-cover mt-[70px]"
        src={descriptionimage}
        alt="Top_image"
      />

      {/* Blog Content */}
      <div className="max-w-[1200px] mx-auto py-[60px]">
        <div className="flex sm:flex-row flex-col px-5 gap-x-[80px] justify-between ">
          <div className="max-w-[650px] font-alibaba">
            {/* Content */}
            <div className="text-[18px] text-font-grey leading-[30px]">
              {property.description.map((block, index) => {
                const text =
                  block.children?.map((child) => child.text).join("") || "";
                if (block.type === "heading") {
                  return (
                    <h2 className="text-[28px] font-bold leading-[36px] mt-10">
                      {" "}
                      {text}
                    </h2>
                  );
                }
                if (block.type === "paragraph") {
                  return <p className="mt-10">{text}</p>;
                }
                return null; // fallback if block type is something else
              })}
            </div>

            {/* Second Blog */}
            <div className="my-[70px]">
              <img
                className="sm:w-[650px] sm:h-[425px] w-full my-[32px] object-cover"
                src={contentimage}
                alt="description_image"
              />
            </div>

            {/* <div className="text-[18px] text-font-grey leading-[30px]">
                <p>Netus sed ac elit magnis sit ac viverra.</p>
                <p className="mt-10">
                  {" "}
                  Eget commodo sit pulvinar varius leo velit nunc nulla
                  fermentum.
                </p>
              </div> */}
          </div>

          {/* Sticky Card */}
          <div className=" relative mx-auto sm:mx-0 sm:sticky top-10 rounded-lg max-w-[380px] h-fit bg-[#F8F6F6] p-8 font-alibaba text-center sm:p-12">
            <img className="w-full" src={apartment_img} />
            <h3 className="text-[27px] font-bold leading-[32px] mt-[40px]">
              Find an apartment in Saravanampatti.
            </h3>
            <p className="max-w-[271px] text-[18px] text-font-grey leading-[26px] mt-5">
              Lorem ipsum dolor sit amet consectetur. Ipsum justo imperdiet
              elit.{" "}
            </p>

            <button className="bg-yellow w-full h-[54px] text-[20px] font-bold mt-7">
              Explore
            </button>
          </div>
        </div>
      </div>

      <Dream_Property />

      {/* Buying */}
      <div className="max-w-fit xl:max-w-[1260px] mx-auto font-alibaba mt-[80px] lg:mt-[120px] px-6 lg:px-0">
        {/* Heading */}
        <div className="w-fit mx-auto space-y-8 xl:flex items-center justify-between xl:w-full">
          <h2 className="text-[30px] font-bold sm:text-[35px]">
            Related Articles
          </h2>
        </div>

        {/* Looping  */}

        <div className="flex flex-wrap justify-between gap-y-10 my-[60px]">
          {article &&
            article
              .filter((item) => item.category === property.category)
              .slice(0, 3)
              .map((items) => ( 
               
                  <div className="w-[399px] h-fit mx-auto border border-[#E3E4E4] rounded-[4px] shadow-lg">
                    {items.image?.length > 0 && items.image[0]?.url && (
                      <img
                        className="w-full h-[229px] relative"
                        src={`http://localhost:1337${items.image[0].url}`}
                        alt={items.alt}
                      />
                    )}
                    {/* <p className=" right-4 top-4 bg-yellow px-4 py-1">
                      {items.category}
                    </p> */}

                    {/* Content */}
                    <div className="p-[28px]">
                      <h1 className="text-[24px] font-bold">{items.heading}</h1>

                      <div className="flex items-center gap-x-[15px] mt-[22px] mb-[25px]">
                        <img
                          className="w-[40px]"
                          src={Profile_avatar}
                          alt="Profile_avatar"
                        />
                        <p className="text-font-grey text-[16px]">
                          {items.user}
                        </p>
                      </div>
                      <p className="text-[16px] text-font-grey leading-[23px]">
                        {items.content.slice(0, 150)}
                      </p>
                    </div>
                  </div>
         
              ))}
        </div>
      </div>

      <Chatwithus />
    </>
  );
}

export default BlogDescription;
